import { useState, useEffect } from 'react';
import LogoNav from '../image/logo_nav.png';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // ✅ Smooth scroll with navbar offset
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        const offset = 80;

        if (element) {
            const top = element.offsetTop - offset;
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        }

        setIsOpen(false); // close mobile menu
    };

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled
            ? 'bg-white/80 backdrop-blur-md shadow-lg py-3'
            : 'bg-transparent py-5'
            }`}>
            <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center">

                {/* Logo */}
                <div
                    onClick={() => scrollToSection('home')}
                    className="flex items-center gap-3 group cursor-pointer"
                >
                    <img
                        src={LogoNav}
                        alt="Genius Bridge Technologies"
                        className="h-10 w-auto transition-transform duration-300 group-hover:scale-110"
                    />
                    <h1 className="text-xl font-bold tracking-tight">
                        Genius
                        <span className="bg-brand-gradient bg-clip-text ml-2 text-transparent">
                            Bridge Technologies
                        </span>
                    </h1>
                </div>

                {/* Desktop Menu */}
                <div className="hidden md:flex items-center space-x-8">

                    <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-brand-primary font-medium">
                        Home
                    </button>

                    <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-brand-primary font-medium">
                        About GBT
                    </button>

                    <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-brand-primary font-medium">
                        Services
                    </button>

                    <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-brand-primary font-medium">
                        FAQ's
                    </button>

                    <button
                        onClick={() => scrollToSection('contact')}
                        className="bg-brand-gradient text-white px-5 py-2 rounded-full text-sm font-semibold 
                        hover:shadow-xl hover:scale-105 transition-all duration-300"
                    >
                        Contact Us
                    </button>
                </div>

                {/* Mobile Button */}
                <div className="md:hidden">
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="text-gray-700 p-2"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {isOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`md:hidden absolute w-full bg-white shadow-xl transition-all duration-300 ${isOpen
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 -translate-y-full pointer-events-none'
                }`}>
                <div className="flex flex-col px-6 py-4 space-y-4">

                    <button onClick={() => scrollToSection('home')} className="text-gray-700 font-medium text-left">
                        Home
                    </button>

                    <button onClick={() => scrollToSection('about')} className="text-gray-700 font-medium text-left">
                        About
                    </button>

                    <button onClick={() => scrollToSection('services')} className="text-gray-700 font-medium text-left">
                        Services
                    </button>

                    <button onClick={() => scrollToSection('faq')} className="text-gray-700 font-medium text-left">
                        FAQ's
                    </button>

                    <button
                        onClick={() => scrollToSection('contact')}
                        className="bg-brand-gradient text-white text-center py-2 rounded-full font-semibold"
                    >
                        Contact Us
                    </button>
                </div>
            </div>
        </nav>
    );
}